<script setup lang="ts">
import { withDefaults } from 'vue';
import { useRouter } from 'vue-router';
import SubjectCard from '@/components/videos/SubjectCard.vue';
import useSubjectsWithVideos from '@/composables/use-subjects-with-videos';
import { useLocale } from '@/plugins/translation';

const { t, l } = useLocale();

withDefaults(
  defineProps<{
    size?: string;
  }>(),
  {
    size: () => 'large',
  },
);

const { subjectsWithVideos, isSecondarySchoolProgram } = useSubjectsWithVideos();
const router = useRouter();

const openCategory = (subject: string) => {
  router
    .push({ name: 'SubjectPage', params: { subject } })
    .then(() => {
      // Shift focus to top of page again after navigation
      const mainContent = document.querySelector('main');
      if (mainContent) {
        mainContent.focus();
      }
    })
    .catch((error) => {
      // todo: check if this is still needed
      if (
        error.name !== 'NavigationDuplicated' &&
        !error.message.includes('Avoided redundant navigation to current location')
      ) {
        console.debug(error);
      }
    });
};
</script>

<template>
  <v-container fluid class="category-container pa-0">
    <v-row>
      <v-col
        v-for="(subject, index) in subjectsWithVideos.filter((s) => !isSecondarySchoolProgram(s.slug!))"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <SubjectCard :subject="subject" :size="size" @open-category="openCategory" />
      </v-col>
    </v-row>
    <v-row v-if="subjectsWithVideos.filter((s) => isSecondarySchoolProgram(s.slug!)).length">
      <v-col cols="12">
        <h2 class="text-secondary my-0 secondary-school-programs">{{ t(l.videos.secondary_school_programs) }}</h2>
      </v-col>
      <v-col
        v-for="(subject, index) in subjectsWithVideos.filter((s) => isSecondarySchoolProgram(s.slug!))"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <SubjectCard :subject="subject" :size="size" @open-category="openCategory" />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@use '@/foundations/theme/settings';
@use 'sass:map';
.category-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  max-width: 90rem !important;
}

.secondary-school-programs {
  font-size: 1.125rem;

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    font-size: 1.375rem;
  }
}
</style>
